import React from "react";
import { Button } from "@material-ui/core";
import { Link} from "react-router-dom";
import QuillNoteHeading from "./UiElements/QuillNoteHeading";

const LoginPage = () => {

  return (
    <div className="loginPage">
      <QuillNoteHeading subHeading="prototype"/>
      <div>
        
        <Link to="/instructor/home">
          <Button
            className="CustomButton w100 d-block"
            variant="contained"
            size="large"
          >
            Instructor Login
          </Button>
        </Link>
        <Link to="/student/login"> 
          <Button
            style={{ marginTop: "10px" }}
            className="CustomButton w100 d-block"
            variant="contained"
            size="large"
          >
            Student Login
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
